import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout';

import './LoginPromptDialog.scss';

function LoginPromptDialog(props) {
  const { selfClose, onSignInClick } = props;

  return (
    <GeneralDialogLayout
      {...props}
      className="remote-access-login-prompt-dialog"
      size="md"
      layoutType="nothing"
      movable={false}
      headerClassName="remote-access-login-prompt-dialog__header rx-border-none"
      header={<h4>Remote access</h4>}
      footerClassName="remote-access-login-prompt-dialog__footer rx-border-none"
      footer={
        <div className="els-btn-group-right">
          <Button
            data-e2e="remote-access-login-prompt-cancel"
            type="tertiary"
            size="small"
            onClick={selfClose}
            className="e2e-remote-access-login-prompt-dialog-cancel">
            Cancel
          </Button>
          <Button
            data-e2e="remote-access-login-prompt-sign-in"
            type="primary"
            size="small"
            onClick={() => {
              onSignInClick();
              selfClose();
            }}
            className="e2e-remote-access-login-prompt-dialog-sign-in">
            Sign in
          </Button>
        </div>
      }
      contentClassName="remote-access-login-prompt-dialog__content">
      The activation of remote access can be done when you are signed in. Please sign in and try again.
    </GeneralDialogLayout>
  );
}

LoginPromptDialog.defaultProps = {
  onSignInClick: () => {},
};

LoginPromptDialog.propTypes = {
  selfClose: PropTypes.func,
  onSignInClick: PropTypes.func,
};

export default LoginPromptDialog;
